import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AttachmentBundlerComponent } from './attachmentBundler.component';
import { BundlerFiltersComponent } from './Bundler-Filters/bundlerFilters.component';
import { HybridAdapterUtility } from 'src/app/Hybrid/hybrid-adapter.utility';

@NgModule({
    imports: [
        CommonModule,
        AttachmentBundlerComponent,
        BundlerFiltersComponent,
    ],
    declarations: [],
    exports: [AttachmentBundlerComponent],
    providers: [],
})
export class AttachmentBundlerModule {
    static setupModule(): void {
        const hybridAdapterUtility = new HybridAdapterUtility();
        hybridAdapterUtility.downgradeNg2Component('sdAttachmentBundler', AttachmentBundlerComponent);
        hybridAdapterUtility.downgradeNg2Component('sdAttachmentBundlerFilters', BundlerFiltersComponent);
    }
}
